import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import PrivateRoutes from './Privateroutes';

import PageAutenticacao from '../layouts/Autenticacao';
import LoginIntegracao from '../pages/LoginIntegracao';
import PageUsuario from '../pages/Usuario';
import PageGaleriaMidia from '../pages/GeleriaMidia';
import Log from '../pages/Log2';
import Configuracoes from '../pages/Configuracoes';
import PerfilUsuairo from '../pages/PerfilUsuario';
import CompartilhadoDownload from '../pages/CompartilhadoDownload';
import Dashboard from '../pages/Dashboard';
import { marcarSessao } from '../services/api';
import { trackPromise } from 'react-promise-tracker';
import services from '../services';
import PageHome from '../pages/Home';

export default function(){
 
  useEffect(() => {

    const callApi = () => {
      if(services.storage.get('isAuthenticated')){

        trackPromise(
          marcarSessao()
          .then((res) => {
            
          })
          .catch((error) => {
            console.error(error);
          })
          );
        }
    };


    let apiCallInterval = setInterval(  callApi, 6000);

    // Limpa os event listeners e intervalo ao desmontar o componente
    return () => {
      clearInterval(apiCallInterval);
    };
  }, []); 

  return(

    <BrowserRouter>
    <Switch>
      <Route path='/' exact component={PageAutenticacao} />
      <Route path='/:idUsuario/:idLink' exact component={CompartilhadoDownload} />
      <Route path='/login-integracao' exact component={LoginIntegracao} />
      <PrivateRoutes path='/home' exact component={PageUsuario} />
      <PrivateRoutes path='/home-banners' exact component={PageHome} />
      <PrivateRoutes path='/galeria-midia' exact component={PageGaleriaMidia} />
      <PrivateRoutes path='/galeria-midia/:compartilharpasta' exact component={PageGaleriaMidia} />
      <PrivateRoutes path='/perfil-usuario' exact component={PerfilUsuairo} />
      <PrivateRoutes path='/configuracoes' exact component={Configuracoes} />
      <PrivateRoutes path='/dashboard' exact component={Dashboard} />
      <PrivateRoutes path='/log' exact component={Log} />
      
    </Switch>
  </BrowserRouter>
    )
  }
 